import { FormItem, Input } from '@vkontakte/vkui';
import PropTypes from 'prop-types';
import './DateInputComponent.css';
import { prepareString } from '../../../helpers/helpers';

export const DateInputComponent = ({error, setError, defaultDate, dateTime, setDateTime, label, errorTextMinValue, errorTextMaxValue}) => {
  const now = new Date();

  const minDate = new Date();
  minDate.setFullYear(now.getFullYear() - 1);
  minDate.setUTCHours(0, 0, 0);

  const maxDate = new Date();
  maxDate.setFullYear(now.getFullYear() + 1);
  maxDate.setUTCHours(23, 59, 59);

  const formatDate = (objectDate) => {
    const day = objectDate.getDate();
    const month = objectDate.getMonth() + 1;
    const year = objectDate.getFullYear();

    return `${year}-${month > 10 ? month : ('0' + month)}-${day > 10 ? day : ('0' + day)}`;
  }

  return (<FormItem
    top={label}
    status={error.length > 0 ? 'error' : ''}
    bottom={error}
  >
    <Input
      className={'DateTimeInput'}
      value={dateTime}
      min={`${formatDate(minDate)}T00:00`}
      max={`${formatDate(maxDate)}T23:59`}
      type={'datetime-local'}
      onChange={(event) => {
        const value = prepareString(event.target.value);

        setDateTime(value ? value : defaultDate);

        const date = new Date(value ? value : defaultDate);
        if (minDate > date) {
          setError(errorTextMinValue);
        } else if (date > maxDate) {
          setError(errorTextMaxValue);
        } else {
          setError('');
        }
      }}
      onBlur={() => {
        const value = new Date(dateTime);
        if (minDate > value) {
          setError(errorTextMinValue);
        } else if (value > maxDate) {
          setError(errorTextMaxValue);
        } else {
          setError('');
        }
      }}
    />
  </FormItem>);
}

DateInputComponent.propTypes = {
  error: PropTypes.string.isRequired,
  setError: PropTypes.func.isRequired,
  defaultDate: PropTypes.string.isRequired,
  dateTime: PropTypes.string.isRequired,
  setDateTime: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  errorTextMinValue: PropTypes.string.isRequired,
  errorTextMaxValue: PropTypes.string.isRequired,
};
